module.exports = __webpack_public_path__ + "static/item--ac--f4@3x.e80d2869.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--ac--f4@3x.png
// module id = 622
// module chunks = 126511778744290